import { mixins, Mods, mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled, { keyframes } from 'styled-components';

export const Overlay = styled.div`
    background: white;
    opacity: 0.5;
    border-radius: ${theme.radius.medium};

    ${mixins.position.absoluteFill};
`;

const showProgressAnimation = keyframes`
    0% {
        transform: scale(0.5);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
`;

export const ProgressWrapper = styled.div`
    display: flex;
    position: relative;
    z-index: 1;
    animation: ${showProgressAnimation} ${theme.duration.medium}ms ease-in-out;
`;

export const Tile = styled.div<StyledMods<Mods<'disabled' | 'progress'>>>`
    width: 100%;
    position: relative;
    border-radius: ${theme.radius.medium};
    border: 1px solid ${theme.color.midnight50};
    padding: 24px 32px;
    width: 100%;
    height: 100%;
    transition: ${theme.duration.medium}ms ease-in-out;

    &:hover {
        ${mods.progress.false`
            border-color: ${theme.color.blue100};
            box-shadow: inset 0 0 0 1px ${theme.color.blue100};
        `};
    }

    ${mods.disabled.true`
        border-color: ${theme.color.silver80};
        background-color: ${theme.color.silver80};
    `};
`;
